let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jRPDh")).then(() => parcelRequire('7hzCE'));